<template>

    <div class="uk-section uk-section-muted uk-section-small">
        <div class="uk-container">
            <ul class="uk-subnav uk-subnav-pill uk-flex uk-flex-center uk-margin-remove-top"
                uk-switcher="animation: uk-animation-fade">
                <li v-for="tag in tags"
                    v-if="tag.id == 1 || tag.id == 3 || tag.id == 4"
                    :key="tag.id"
                >
                    <a>{{ tag.name }}</a></li>
            </ul>

            <div class="uk-switcher uk-margin">
                <div v-for="tag in tags"
                     v-if="tag.id == 1 || tag.id == 3 || tag.id == 4"
                     :key="tags.id"
                     style="padding: 0 40px;">

                    <div class="uk-position-relative" uk-slider>

                        <div class="uk-slider-container">

                            <div class="uk-slider-items uk-child-width-1-3@s uk-child-width-1-4@ uk-grid-medium uk-grid-match" uk-grid>

                                <product v-for="Product in ShopItems[tag.id]" :key="Product.ShopItem.id"
                                         :shop-item="Product.ShopItem"
                                         :image="Product.Asset"
                                         :shop-item-prices="ShopItemPrices[Product.ShopItem.id]"
                                         :shop-item-properties="ShopItemProperties[Product.ShopItem.id]"
                                         :shop-item-warehouses="ShopItemWarehouses[Product.ShopItem.id]"
                                         :shop-item-tags="ShopItemTags[Product.ShopItem.id]"
                                         :shop-order-item="page.ShopOrderItems[Product.ShopItem.id]"
                                         @buy-shop-item="buy"
                                ></product>
                            </div>

                        </div>

                        <a class="uk-position-center-left-out tm-slider-nav uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
                        <a class="uk-position-center-right-out tm-slider-nav uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>

                    </div>

                    <div class="uk-text-center uk-margin-medium-top">
                        <a class="uk-link-muted uk-text-uppercase"
                           :href="tag.href">
                            <span class="uk-text-middle">Смотреть {{ tag.name.toLowerCase() }}</span>
                            <span class="uk-text-middle"
                                  uk-icon="icon: chevron-right"></span></a>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Product from "./Product/Product";
    import ShopProductsMixin from "./ShopProductsMixin";

    export default {
        name: "HomeTags",
        components: {Product},
        mixins: [ShopProductsMixin],
        props: {
            tags: {
                type: Array
            },
            ShopItems: {
                type: [Object, Array]
            }
        },
        data(){
            return {
                page: {
                    ShopOrderItems: this.ShopOrderItems
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// HomeTags.vue?c0c757f8